import { CommonColors } from "@api/types/ui";
import cn from "classnames";
import styles from "./avatar.module.scss";

export interface IAvatarProps {
  src: string;
  alt: string;
  width?: "none" | "20" | "40" | "52" | "64" | "74";
  borderColor?: "none" | CommonColors | string;
  className?: string;
}

const Avatar = ({
  className = "",
  borderColor = "none",
  width = "none",
  ...rest
}: IAvatarProps): JSX.Element => {
  const classNames = cn(styles.avatar, className, {
    [styles[`avatar-border-color-${borderColor}`]]: borderColor,
    [styles.withBorder]: borderColor !== "none",
    [styles[`avatar-width-${width}`]]: width,
  });

  return <img className={classNames} {...rest} />;
};

export default Avatar;
